
    import Component from "vue-class-component";
    import Vue from "vue";
    import {Prop} from "vue-property-decorator";

    @Component
    export default class SectionPageHeading extends Vue {
        @Prop({type: Boolean, default: undefined})
        divider!: boolean | undefined;
    }
